module.exports = __webpack_public_path__ + "img/Flag_of_Turkmenistan.5610b891.svg";